<div class="d-lg-none d-block widget-mobile pt-3 container">
  <fgb-navigation-pills [navItems]="jetCashNavItems" />
</div>

<div class="container mt-4">
  <div class="d-lg-none d-block">
    <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
  </div>
</div>
